import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    description: {
        fontSize: "1.2em",
        color: "#8F9194",
        fontFamily: "Inter"
    },
}));


interface ITextStepDescriptionProps {
    currentStep: number;
    totalSteps: number;
}

export default function StepDescription(props: ITextStepDescriptionProps) {
    
    const classes = useStyles();

    return (
        <Typography className = { classes.description }>
            Passo {props.currentStep} de {props.totalSteps}
        </Typography>
    );
}